import { render, staticRenderFns } from "./SelectionSection.vue?vue&type=template&id=89833832&scoped=true&"
import script from "./SelectionSection.vue?vue&type=script&lang=js&"
export * from "./SelectionSection.vue?vue&type=script&lang=js&"
import style0 from "./SelectionSection.vue?vue&type=style&index=0&id=89833832&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89833832",
  null
  
)

export default component.exports